{
  "name": "@replit/vite-plugin-cartographer",
  "version": "0.4.2",
  "private": false,
  "devDependencies": {
    "@replit/tsconfig": "workspace:*",
    "@types/babel__core": "^7.20.5",
    "@types/babel__traverse": "^7.20.6",
    "@types/node": "^22.5.5",
    "@typescript-eslint/eslint-plugin": "^6.7.0",
    "@typescript-eslint/parser": "^6.7.0",
    "happy-dom": "^20.0.2",
    "tsup": "^8.3.5",
    "tsx": "^4.9.5",
    "vite": "^5.4.10",
    "vitest": "^3.2.4"
  },
  "main": "./src/index.ts",
  "files": [
    "src"
  ],
  "scripts": {
    "build": "tsup",
    "lint": "eslint src",
    "format": "prettier --write \"src/**/*.ts\"",
    "test": "vitest"
  },
  "dependencies": {
    "@babel/parser": "^7.26.9",
    "@babel/traverse": "^7.26.9",
    "@babel/types": "^7.26.9",
    "magic-string": "^0.30.12",
    "modern-screenshot": "^4.6.0"
  }
}
